import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const ResetPasswordDialog = ({ open, onClose, onReset }) => {
  const [password, setPassword] = useState("");

  const handleReset = () => {
    onReset(password);
    setPassword("");
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="New Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleReset}
          variant="contained"
          color="primary"
          disabled={!password}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordDialog;
